module.exports = __webpack_public_path__ + "static/media/Noctowl_gaussian2.a937ef66.png";